import React from 'react';
var WindowEventContext = React.createContext({});
export var WindowEventProvider = WindowEventContext.Provider;
export var WindowEventConsumer = WindowEventContext.Consumer;
export default WindowEventContext;
//# sourceMappingURL=window-event-context.js.map